// extracted by mini-css-extract-plugin
export default {"triggerContainer":"Panel-module-triggerContainer","contentContainer":"Panel-module-contentContainer"};